import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { IndianCurrencyDisplay } from "../../utils/Helper";

const COLORS = ["rgb(54, 119, 101)", " rgb(245, 164, 64)", "rgb(171, 220, 50)"];
// const COLORS = ["rgb(54, 119, 101)", " rgb(245, 164, 64)"];

const DonutChart = ({ loading, data }) => {

  const getRevenue = () => {
    const sales = data.find((item) => item.name === "Sales")?.amount || 0;
    const expenses = data.find((item) => item.name === "Expenses")?.amount || 0;
    const profit = sales - expenses;
    console.log("UYT39", profit);
    const isProfit = profit > 0
    const retVal = {
      amount: Math.abs(profit),
      profit: isProfit
    }
    return retVal
  }

  return (
    <>
      {
        loading ? <></> : (<>
          <ResponsiveContainer width={'100%'} >
            <PieChart width={'100%'} height={'100%'}>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={85}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="amount"
                // label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                label={({ amount }) => `₹ ${(amount).toFixed(2)}`}

              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="total_count_div_wrapper26523">
            <p>Total Revenue</p>
            <h4><IndianCurrencyDisplay amount={getRevenue().amount} isPositive={getRevenue().profit} /></h4>
          </div>

        </>)
      }

    </>
  );
};

export default DonutChart;